import Elixia from '@sats-group/ui-lib/react/logos/elixia';
import ElixiaSmall from '@sats-group/ui-lib/react/logos/elixia-anniversary-light';
import Sats from '@sats-group/ui-lib/react/logos/sats';
import SatsSmall from '@sats-group/ui-lib/react/logos/sats-anniversary-light';
import React from 'react';
import type { Logo as Props } from './logo.types';
import { brands, colors, sizes } from './logo.types';

/**
 * When we don't need to render the anniversary version of the small logo anymore,
 * reimport the regular small logos.
 *
 * ```
 * import ElixiaSmall from '@sats-group/ui-lib/react/logos/elixia-small';
 * import SatsSmall from '@sats-group/ui-lib/react/logos/sats-small';
 * ```
 */

const vectors = {
  [brands.elixia]: {
    [sizes.large]: Elixia,
    [sizes.small]: ElixiaSmall,
  },
  [brands.sats]: {
    [sizes.large]: Sats,
    [sizes.small]: SatsSmall,
  },
};

const Logo: React.FC<Props> & {
  colors: typeof colors;
  brands: typeof brands;
  sizes: typeof sizes;
} = ({
  brand = brands.sats,
  color = colors.light,
  href,
  label,
  size = sizes.small,
}) => {
  const Vector = vectors[brand][size];

  return (
    <div className={`logo logo--${color}`}>
      {href ? (
        <a aria-label={label} className="logo__link" href={href}>
          <Vector />
        </a>
      ) : (
        <Vector />
      )}
    </div>
  );
};

Logo.colors = colors;
Logo.brands = brands;
Logo.sizes = sizes;

export default Logo;
